import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageUsers() {
            return Auth.hasPermissionTo('franchise_manage_users');
        },

        canCreateUsers() {
            return Auth.hasPermissionTo('franchise_create_users');
        },

        canUpdateUsers() {
            return Auth.hasPermissionTo('franchise_update_users');
        },

        canDeleteUsers() {
            return Auth.hasPermissionTo('franchise_delete_users');
        },
    },

    methods: {
        canEditUser(u) {
            return !u.is_franchise_onwer;
        },

        canManageUser(u) {
            if (u.id) {
                return (
                    !u.is_franchise_onwer &&
                    (this.canManageUsers || this.canUpdateUsers)
                );
            } else {
                return this.canManageUsers || this.canCreateUsers;
            }
        },

        getUserPhoto(u) {
            if (u.profile_photo_url != null) {
                return u.profile_photo_url;
            }

            return '/img/placeholder-pic.jpg';
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/user/user-mixin.js